var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPostLike({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.78959 17.1785C6.88894 15.9411 5.12239 14.4895 3.5213 12.8492C2.3897 11.6606 1.52825 10.2186 1.0013 8.63077C0.06179 5.53846 1.15936 2.00308 4.25009 0.960002C5.05089 0.689764 5.90155 0.625012 6.73102 0.77115C7.56049 0.917288 8.34466 1.27004 9.01789 1.79998C9.69012 1.27152 10.4727 0.919573 11.3005 0.77346C12.1283 0.627347 12.9774 0.691323 13.7769 0.960002C16.8676 2.00308 17.974 5.57538 17.0345 8.63077C16.5117 10.2207 15.6497 11.6637 14.5145 12.8492C12.9134 14.4895 11.1468 15.9411 9.24619 17.1785L9.04421 17.3077L8.78959 17.1785Z",
    stroke: "#767676",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPostLike);
export default __webpack_public_path__ + "static/media/post_like.9097459db7c76bd17a0b877b78434448.svg";
export { ForwardRef as ReactComponent };